import React from 'react';
import NavWorkflowsContainer from '../../containers/NavWorkflowsContainer';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';
import config from '../../config';
import RenderIcon from '../commons/RenderIcon';
import cleanImageUrl from '../../utils/cleanImageUrl';

class DesktopWorkflowTopBarWithSideBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: -1
    }
  }

  componentDidMount() {
    this.props.fetchWorkflows(this.props.user);
  }



  resolveIsActive = (match, location) => {
    if (!match || !location) {
      return false
    }
    const { path } = match;
    const { pathname } = location;
    if (pathname === path) {
      return true;
    }
    return false;
  }

  setActiveTab = (tabIndex) => {
    this.setState({ activeTab: tabIndex });
  }
  render() {
    const { router } = this.context;
     const { customIcons } = this.props
    const { isActive, isPublic, baseWorkflowRoute, isScreenerMonkeyApp, items, companySettings, user } = this.props;
    const sideMenuConfig = companySettings ? companySettings : null
    const onlySignOut = sideMenuConfig && sideMenuConfig.sideMenuDefaultLogout ? sideMenuConfig.sideMenuDefaultLogout : null;

    const userInfo = user && user.user;
    let fullName = null;
    if (userInfo && !userInfo.lastName) {
      fullName = `${userInfo.firstName}`
    }
    if (userInfo && userInfo.lastName) {
      fullName = `${userInfo.firstName} ${userInfo.lastName}`;
    }
    if (userInfo && userInfo.firstName === userInfo.lastName) {
      fullName = `${userInfo.firstName} `;
    }
    const profilePic = user && user.user && user.user.profilePicture;

    const profilePicURL = profilePic ? cleanImageUrl(config.assetsBasePath + profilePic) : null
    const parentItemIcon = this.props.companySettings && this.props.companySettings.cssClass ? this.props.companySettings.cssClass : null
    const parentItemCustomIcon = this.props.companySettings && this.props.companySettings.cssCustomWeb ? this.props.companySettings.cssCustomWeb : null
    const parentItemCustomIconSize = this.props.companySettings && this.props.companySettings.cssCustomWeb ? this.props.companySettings.cssCustomWebSize : null
   
    const iconConfig = {
      cssClass: parentItemIcon,
      cssClass2: parentItemIcon,
      cssCustomIconMenu: parentItemCustomIcon,
      webIconSizeMenu: parentItemCustomIconSize // custom icon Size  
    }
   
    return (
      <div className={`desktop-menu-items ${isPublic ? 'hide-menu' : ''}`}>
        <ul className="desktop-level-one-menu">
          {/* <li className="desktop-level-one-menu-item home" key={-1}>
			  <NavLink className={`desktop-level-one-menu-item-link ${isScreenerMonkeyApp ? 'screener-monkey' : ''}`} to={isPublic ? '/' : '/app'}>
          <span>
            <i className='fa fa-home'></i>
          </span>
			  </NavLink>
		  </li>	   */}
          {
            items && (
              Array.isArray(items) && items.map((parentItem, parentIndex) => {
                if (!parentItem.alwaysInTopMenu) return null;
                let parentItemProperties = parentItem && parentItem.properties ? parentItem.properties : null
                if (parentItemProperties !== null) {
                  var obj = JSON.parse(parentItemProperties);
                  var parentItemIconObject = obj
                }
                const mobileOnly = parentItemIconObject && parentItemIconObject.displayMode ? parentItemIconObject.displayMode : null
                if (parentItem.hideInMenu) return null;
                if (mobileOnly && mobileOnly.value === 2) return null;
                const hasChildren = parentItem.childMenus && parentItem.childMenus.length > 0;
                const routerBase = router.route.match.path;
                const parentPath = `${baseWorkflowRoute}/${parentItem.friendlyUrl.toLowerCase()}`;
                const { title } = parentItem;
                return hasChildren ? (
                  <li key={parentIndex} className={`desktop-level-one-menu-item wf-topbar-only ${this.state.activeTab === parentIndex ? 'active' : ''}`} onMouseOver={() => this.setActiveTab(parentIndex)}>
                    <a className={`desktop-level-one-menu-item-link ${isScreenerMonkeyApp ? 'screener-monkey' : ''}`}>
                      {parentItem.title}
                      <span className="right-icon-container">
                        <i className='fa fa-chevron-down'></i>
                      </span>
                    </a>
                    <DesktopLevelTwoMenu>
                      <ul className="desktop-level-two-menu-items">
                        {
                          parentItem.childMenus.map((child, childIndex) => {
                            if (child.hideInMenu) return null;
                            const path = `${baseWorkflowRoute}/${child.friendlyUrl.toLowerCase()}`;
                            const childPath = `${path}`;
                            return <li className="desktop-level-two-menu-item sidebarwithTopBar-item" key={childIndex}>
                              <NavLink className="desktop-level-two-menu-item-link sidebarwithTopBar-item-link" to={childPath} >
                                {child.title}
                                <span className="right-icon-link">
                                  <i className='fa fa-arrow-circle-o-right'></i>
                                </span>
                              </NavLink>
                            </li>
                          })
                        }
                      </ul>
                    </DesktopLevelTwoMenu>
                  </li>
                ) : <li className="desktop-level-one-menu-item sidebarwithTopBar-item" key={parentIndex} id={parentItem.friendlyUrl}>
                  <NavLink className={` sidebarwithTopBar-item-link`} to={parentPath}>
                    <i className={`custom-icon-class fa ${parentItem.menuIcon ? parentItem.menuIcon : ''}`} style={!parentItem.onlyIcon ? { marginRight: 5 } : {}}></i>
                    {!parentItem.onlyIcon ? <span>{parentItem.title}</span> : <UncontrolledTooltip delay={100} placement='bottom' target={parentItem.friendlyUrl}>
                      {parentItem.title}
                    </UncontrolledTooltip>}
                  </NavLink>
                </li>
              }
              )
            )
          }





          {!isPublic && userInfo &&
            <li className={`desktop-level-one-menu-item sidebarwithTopBar-item ${this.state.activeTab === items ? items.length + 1 : 2 ? 'active' : ''}`} onMouseOver={() => this.setActiveTab(items ? items.length + 1 : 2)}>
              {profilePicURL ? <img src={profilePicURL} alt="profilePIC" className='profilePic_Menu' /> :  <RenderIcon config={iconConfig} customIcons={customIcons} />}
              <a className={`sidebarwithTopBar-item-link ${isScreenerMonkeyApp ? 'screener-monkey' : ''}`}>

                {fullName}
                <span className="right-icon-container">
                  <i className='fa fa-chevron-down'></i>
                </span>
              </a>
              <DesktopLevelTwoMenu>
                <ul className="desktop-level-two-menu-items ">
                  {/* <li className=" sidebarwithTopBar-item">
                      <NavLink className=" sidebarwithTopBar-item-link" to="/profile" >
                        Profile
                        <span className="right-icon-container">
                          <i className='fa fa-user'></i>
                        </span>
                      </NavLink>
                    </li> */}
                  <li className="sidebarwithTopBar-item">
                    <a className="sidebarwithTopBar-item-link" href="#" onClick={() => this.props.logout()} >
                      Sign Out
                      <span className="left-icon-container">
                        <i className='fa fa-sign-out'></i>
                      </span>
                    </a>
                  </li>
                </ul>
              </DesktopLevelTwoMenu>
            </li>

          }


        </ul>
      </div>
    )
  }
}

const DesktopLevelTwoMenu = (props) => {
  return <div className="desktop-level-two-menu wf-topbar-only">
    {props.children}
  </div>
}

DesktopWorkflowTopBarWithSideBar.contextTypes = {
  router: PropTypes.object
}

export default DesktopWorkflowTopBarWithSideBar;